import * as React from 'react';
import { Icon, IconProps } from '../Icon';

export const ArrowLeft: React.FC<IconProps> = (props) => (
  <Icon viewBox="0 0 15 15" {...props}>
    <path d="M.86 7.15c.175 0 .351.067.485.201l6.277 6.277a.687.687 0 01-.971.97L.374 8.323A.687.687 0 01.86 7.149" />
    <path d="M2.4 7.077h11.413a.687.687 0 110 1.373H2.401a.686.686 0 110-1.373" />
    <path d="M7.136.8a.687.687 0 01.485 1.173L1.346 8.248a.687.687 0 11-.972-.97L6.652 1C6.785.867 6.961.8 7.136.8" />
  </Icon>
);
